const warningHandler = {
  get: function (target, name) {
    if (
      // eslint-disable-next-line
      !target.hasOwnProperty(name) &&
      !String(name).includes("__v") && // ignore Vue accessing stuff
      String(name) !== "Symbol(Symbol.toStringTag)" // ignore whatever this is
      //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag
    ) {
      console.error("Accessing undefined property:", name);
      console.trace();
      throw new Error("Accessing undefined property: " + name);
    }
    return target[name];
  }
};

/**
 * Keys that are used in the activity
 * NOTE: the arrow keys are no longer used due to conflict with button navigation in the sidebar
 */
export const KEYS = new Proxy(
  {
    SHIFT: "shift",
    LEFT: "left",
    UP: "up",
    DOWN: "down",
    RIGHT: "right",
    I: "i",
    J: "j",
    K: "k",
    L: "l",
    W: "w",
    A: "a",
    S: "s",
    D: "d"
  },
  warningHandler
);

export const STATUS = new Proxy(
  {
    INIT: "Init",
    POINT_SELECTION: "Point Selection",
    COARSE_ALIGNMENT: "Coarse Alignment",
    FINE_ALIGNMENT: "Fine Alignment",
    ROTATING_TO_INVERSE: "Rotating to Inverse"
  },
  warningHandler
);

export const DIRECTION = new Proxy(
  {
    UP: "Up",
    DOWN: "Down",
    LEFT: "Left",
    RIGHT: "Right"
  },
  warningHandler
);

// Height of total station tripod model
export const TRIPOD_HEIGHT = 1.16;

// Measured Height of the center of the total station model's sight, relative to the model origin
export const SIGHT_HEIGHT_IN_MODEL = 0.28292;

// Overall height of the center of the total station model's sight, relative to the scene origin
export const SIGHT_HEIGHT = TRIPOD_HEIGHT + SIGHT_HEIGHT_IN_MODEL;

// Overall height of the target pole model
export const POLE_HEIGHT = 1.38;

// Height to center of mirror in target model, from model origin
export const TARGET_CENTER_HEIGHT = 0.087;

// Height of the target pole model to display in the data output table - IN FEET
// This was requested by the instructor since it is the common height for target poles
// This is not the actual height of the target in 3D space, but the height of the target pole model to display in the data output table
// This works out ok since height differences are not really used in this lab
export const DISPLAYED_TARGET_HEIGHT = 5;

export const USE_SHADOWS = true;

// Degrees per second to rotate the camera
export const DEGREES_PER_SECOND = 0.0002777778;
